import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './apple-device.reducer';
import { AppleDeviceState } from './apple-device.state';

import { DevicesRouterStoreSelectors } from '../router';
import { DeviceLink, DeviceType } from '@era/locations-sdk';

export const selectAppleDeviceState = createFeatureSelector<AppleDeviceState>('apple-devices');

export const selectDeviceIds = createSelector(selectAppleDeviceState, fromReducer.selectDeviceIds);

export const selectAppleDeviceEntities = createSelector(selectAppleDeviceState, fromReducer.selectAppleDeviceEntities);

export const selectAllDevices = createSelector(selectAppleDeviceState, fromReducer.selectAllDevices);

export const selectAppleDeviceByUdid = (udid: string) =>
  createSelector(selectAppleDeviceEntities, (appleDevices) => appleDevices[udid]);

export const selectCurrentAppleDevice = createSelector(
  selectAppleDeviceEntities,
  DevicesRouterStoreSelectors.selectUdid,
  (appleDevices, udid) => appleDevices[udid]
);

export const selectCurrentDeviceLink = createSelector(selectCurrentAppleDevice, (appleDevice) => {
  return {
    deviceId: appleDevice.udid,
    deviceType: DeviceType.Apple,
  } as DeviceLink;
});
